// extracted by mini-css-extract-plugin
export default {"container":"PermissionManagement_container__tvGYB","wrapperButton":"PermissionManagement_wrapperButton__04SDl"};